import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BASE_URL from "api/Api";
import { FaFlag, FaPlus, FaEdit, FaTrash, FaCheck, FaTimes, FaCamera } from "react-icons/fa";
import "assets/theme/admin_list.css";

const PartyList = () => {
  const [parties, setParties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [editImage, setEditImage] = useState(null);

  const [editData, setEditData] = useState({
    party_name: "",
    short_name: "",
  });

  // Fetch parties
  useEffect(() => {
    setLoading(true);
    fetch(`${BASE_URL}super_admin/list_parties`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setParties(data.parties || data);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  // Start editing
  const handleEdit = (party) => {
    setEditId(party.party_id);
    setEditData({
      party_name: party.party_name,
      short_name: party.short_name,
    });
    setEditImage(null);
  };

  // Cancel edit
  const handleCancel = () => {
    setEditId(null);
    setEditData({ party_name: "", short_name: "" });
  };

  // Save edit
  const handleSave = async (id) => {
    try {
      const formData = new FormData();
      formData.append("party_name", editData.party_name);
      formData.append("short_name", editData.short_name);

      if (editImage) {
        formData.append("symbol_image", editImage);
      }

      const res = await fetch(
        `${BASE_URL}super_admin/edit_parties/${id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: formData,
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      setParties((prev) =>
        prev.map((p) =>
          p.party_id === id
            ? {
                ...p,
                ...editData,
                symbol_image: editImage
                  ? data.symbol_image
                  : p.symbol_image,
              }
            : p
        )
      );

      handleCancel();
    } catch (error) {
      alert(error.message);
    }
  };

  // Delete party
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this party?")) return;

    try {
      const res = await fetch(`${BASE_URL}super_admin/delete_parties/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!res.ok) throw new Error("Failed to delete party");

      setParties((prev) => prev.filter((p) => p.party_id !== id));
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaFlag />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  Party Management / राजकीय पक्ष व्यवस्थापन
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  Manage political party profiles, short names, and symbols
                </p>
              </div>
            </div>

            <Link to="/parties" className="btn btn-admin-add">
              <FaPlus /> <span>Add Party / पक्ष जोडा</span>
            </Link>
          </div>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="text-muted mt-2 fw-semibold mb-0">माहिती लोड होत आहे...</p>
              </div>
            ) : parties.length === 0 ? (
              <div className="text-center py-5">
                <FaFlag className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">No parties available</h6>
                <p className="text-muted small mb-0">No political party records have been found.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-admin-custom align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Sr. No.</th>
                      <th style={{ width: "90px" }}>Symbol</th>
                      <th>Party Name</th>
                      <th>Short Name</th>
                      <th className="text-center" style={{ width: "160px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {parties.map((party, index) => (
                      <tr key={party.party_id}>
                        <td>
                          <span className="fw-semibold text-muted">{(index + 1).toString().padStart(2, "0")}</span>
                        </td>

                        {/* Symbol */}
                        <td>
                          {editId === party.party_id ? (
                            <div className="d-flex flex-column align-items-center gap-1">
                              <img
                                src={
                                  editImage
                                    ? URL.createObjectURL(editImage)
                                    : `${BASE_URL}${party.symbol_image}`
                                }
                                alt="symbol"
                                className="rounded-circle shadow-sm border"
                                style={{
                                  width: "44px",
                                  height: "44px",
                                  objectFit: "cover",
                                }}
                              />
                              <label className="btn btn-xs btn-outline-primary py-0 px-1 style-small" style={{ fontSize: "0.7rem" }}>
                                <FaCamera className="me-1" />
                                <input
                                  type="file"
                                  hidden
                                  accept="image/*"
                                  onChange={(e) => setEditImage(e.target.files[0])}
                                />
                              </label>
                            </div>
                          ) : (
                            <div className="admin-avatar-chip p-1 border shadow-sm rounded-circle bg-white">
                              <img
                                src={`${BASE_URL}${party.symbol_image}`}
                                alt="symbol"
                                className="rounded-circle"
                                style={{
                                  width: "42px",
                                  height: "42px",
                                  objectFit: "cover",
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = "none";
                                }}
                              />
                            </div>
                          )}
                        </td>

                        {/* Party Name */}
                        <td>
                          {editId === party.party_id ? (
                            <input
                              type="text"
                              className="form-control form-control-sm border-warning fw-semibold shadow-sm"
                              value={editData.party_name}
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  party_name: e.target.value,
                                })
                              }
                            />
                          ) : (
                            <span className="fw-bold text-dark">{party.party_name}</span>
                          )}
                        </td>

                        {/* Short Name */}
                        <td>
                          {editId === party.party_id ? (
                            <input
                              type="text"
                              className="form-control form-control-sm border-warning fw-semibold shadow-sm"
                              value={editData.short_name}
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  short_name: e.target.value,
                                })
                              }
                            />
                          ) : (
                            <span className="badge bg-primary bg-opacity-10 text-primary fw-bold px-3 py-1 rounded-pill">
                              {party.short_name}
                            </span>
                          )}
                        </td>

                        {/* Actions */}
                        <td>
                          <div className="d-flex justify-content-center gap-2">
                            {editId === party.party_id ? (
                              <>
                                <button
                                  className="btn btn-sm btn-success px-3 fw-semibold text-white d-flex align-items-center gap-1"
                                  onClick={() => handleSave(party.party_id)}
                                >
                                  <FaCheck /> <span>Save</span>
                                </button>
                                <button
                                  className="btn btn-sm btn-secondary px-2 d-flex align-items-center gap-1"
                                  onClick={handleCancel}
                                >
                                  <FaTimes />
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn-action-icon edit"
                                  title="Edit Party"
                                  onClick={() => handleEdit(party)}
                                >
                                  <FaEdit />
                                </button>
                                <button
                                  className="btn-action-icon delete"
                                  title="Delete Party"
                                  onClick={() => handleDelete(party.party_id)}
                                >
                                  <FaTrash />
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PartyList;
